// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '화이트생명과학',
  targetSheetName: '수수료율표',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  fillMergedMappedColumns: true,
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '구분',
    '분류번호',
    '분류명',
    '보험코드',
    '제품명',
    '보험약가',
    '규격',
    '포장단위',
    '성분명',
    '대조약',
    '수수료율',
    '비고',
  ],
});
